import { render, staticRenderFns } from "./ShopOptions.vue?vue&type=template&id=6a2566ce&scoped=true"
import script from "./ShopOptions.vue?vue&type=script&lang=js"
export * from "./ShopOptions.vue?vue&type=script&lang=js"
import style0 from "./ShopOptions.vue?vue&type=style&index=0&id=6a2566ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2566ce",
  null
  
)

export default component.exports